import { generateDaysForLocale } from 'pos-shared/utils/dateTimeHelpers.ts';

export const useWeekdays = (locale?: string) => {
  const weekdays = generateDaysForLocale(locale).map((item) => ({
    value: item,
    label: item,
  }));

  return weekdays;
};
